<template>
  <div class="c-prominents">
    <div
      class="c-prominent"
      v-for="item in items"
      :key="item.key"
    >
      <div class="c-prominent__value">{{ item.value }}</div>
      <div class="c-prominent__key">{{ item.key }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OProminents',
  props: {
    items: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>

<style lang="scss">
.c-prominents {
  display: flex;
  padding: 2.4rem 0;
}

.c-prominent {
  flex: 1;
  padding: 0.8rem 0;
  text-align: center;

  & + & {
    border-left: 0.1rem solid rgba(#000, 0.1);
  }
}

.c-prominent__value {
  color: $primary-color;
  color: var(--primary-color);
  font-size: 3.2rem;
  font-weight: 600;
  letter-spacing: -0.1rem;
  line-height: 1;
  margin-bottom: 1.6rem;
}
</style>
